{
  "longPressMessage": "Нажмите и удерживайте, чтобы открыть предварительный просмотр"
}
